import { NavigationCombined } from './type';


export const ref = (internal: boolean, urlPrefix = ''): NavigationCombined => {
  return {
    app: 'ref',
    order: 3,
    label: 'Reference',
    icon: 'settings',
    flat: false,
    prefix: 'reference',
    title: 'Reference',
    children: [
      {
        label: 'Grades',
        link: !internal ? `${ urlPrefix }/reference/grades` : null,
        route: internal ? [ '/', 'grades' ] : null,
      },
      {
        label: 'Companies',
        link: !internal ? `${ urlPrefix }/reference/companies` : null,
        route: internal ? [ '/', 'companies' ] : null,
      },
      {
        label: 'Countries',
        link: !internal ? `${ urlPrefix }/reference/countries` : null,
        route: internal ? [ '/', 'countries' ] : null,
      },
      {
        label: 'Terminals',
        link: !internal ? `${ urlPrefix }/reference/terminals` : null,
        route: internal ? [ '/', 'terminals' ] : null,
      },
    ],
  }
}
